import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const citizenshipService = {
    async getAll(token: string, params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);

            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/citizenship/all`,
                paramsCopy,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching directory list:", error);
            throw error;
        }
    },

    async findById(citizenshipId: number): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/citizenship/findById/${citizenshipId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById citizenship", error);
            throw error;
        }
    },

    async save(citizenship: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/citizenship/save`,
                citizenship
            );
            return response.data;
        } catch (error) {
            console.error("Error save citizenship", error);
            throw error;
        }
    },

    async deleteById(citizenshipId: number): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/citizenship/deleteById/${citizenshipId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById citizenship", error);
            throw error;
        }
    }
}

export default citizenshipService;